export interface DatePickerModel {
    from?: Date;
    to?: Date;
    label?: string;
}

export enum AvalableDateLabels {
    Today = "Today",
    Yesterday = "Yesterday",
    Last7Days = "Last 7 Days",
    Last14Days = "Last 14 Days",
    Last30Days = "Last 30 Days",
    Last60Days = "Last 60 Days",
    Last90Days = "Last 90 Days",
    Last180Days = "Last 180 Days",
    Last365Days = "Last 365 Days",
}

export enum AvailableWeeks {
    ThisWeek = "This week",
    LastWeek = "Last Week",
    TwoWeeksAgo  = "2 weeks ago",
    ThreeWeeksAgo = "3 Weeks ago",
    FourWeeksAgo = "4 weeks ago",
}